import { cronLabel } from './cronLabel'
import { cronToParts, DAY_NAMES } from './cronParts.js'

const at = (parts) =>
  `${String(parts.hour).padStart(2, '0')}:${String(parts.minute).padStart(2, '0')}`

const zone = (timezone) => (timezone ? ` ${timezone}` : '')

export function cronContextLabel(cron, timezone) {
  const parts = cronToParts(cron)
  if (!parts || parts.repeat === 'unknown') return cronLabel(cron, timezone)
  const stamp = `${at(parts)}${zone(timezone)}`
  if (parts.repeat === 'weekly' && parts.weekdays?.length) {
    const day = DAY_NAMES[parts.weekdays[0]]
    return `${stamp}, Every ${day}`
  }
  if (parts.repeat === 'daily') return `${stamp}, Every day`
  if (parts.repeat === 'weekdays') return `${stamp}, Every weekday`
  return cronLabel(cron, timezone)
}
